import React, {Component} from 'react'
import {Button, Segment} from 'semantic-ui-react'
import { connect } from "react-redux"
import {gunaldiStyles} from "../../SharedComponents/GunaldiDesignStyles";
import API_Root_Lambda from "../../Constants/API_Root_Lambda";
import {toggleToast} from "../../Actions/ToggleToast";


class GoToBillingPortalBtn extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false
        }
    }

    goToBillingPortal = () => {
        this.setState({loading: true})
        const error = () => {
            this.setState({loading: false}, () => {
                this.props.toggleToast({
                    show: true,
                    message: "There was an error. Please try again and contact support",
                    type: "error"
                })
            })
        }

        fetch(API_Root_Lambda + "api/create-api-spreadsheets-billing-portal-session/", {
            method: "POST",
            headers: {
                'Accept': 'application/json, text/plain, */*',
            },
            body: JSON.stringify({
                isTest: window.location.origin.includes("localhost"),
                email: localStorage.getItem("email"),
                token: localStorage.getItem("token"),
                returnUrl: window.location.href
            })
        }).then(res=>{
            if (res.status === 200) {
                res.json().then(data => {
                    this.setState({
                        loading: false,
                    }, () => window.location.href = data.url)
                }).catch(err => error());
            } else {
                error()
            }
        }).catch(err => error());
    }

    render() {
        return (
            <Button content="Go to billing portal"
                    icon="arrow right"
                    labelPosition="left"
                    style={gunaldiStyles.btnGreen}
                    loading={this.state.loading}
                    onClick={this.goToBillingPortal}/>
        )
    }
}

const mapStateToProps = (state) => ({
    // subscriptionInfo: state.mainState.subscriptionInfo,
    // currRequests: state.mainState.currRequests,
    // tier: state.mainState.tier,
    // appsumoPlanName: state.mainState.appsumoPlanName,
    // isGrandfather: state.mainState.isGrandfather,
    // currency: state.mainState.currency,
    // yearlyPricing: state.mainState.yearlyPricing,
    // fullPricingInfo: state.mainState.fullPricingInfo
})

const mapActionsToProps = {
    toggleToast: toggleToast
}

export default connect(mapStateToProps, mapActionsToProps)(GoToBillingPortalBtn)